import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1389b3a1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "v-toast" }
const _hoisted_2 = { class: "inner" }
const _hoisted_3 = { class: "message" }

import { onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { getToastType, getDefaultToastType } from './toastTypes'
import iconVue from '../icon'

interface toastApiType {
  message?: string
  duration?: number
  type?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    message: { default: '' },
    duration: { default: 2000 },
    type: { default: 'normal' }
  },
  setup(__props: any) {

const props = __props as { message: string, duration: number, type: string }

_useCssVars(_ctx => ({
  "06097337": (alert.color),
  "64aab4f2": (alert.bgColor)
}))



const alert = reactive(getDefaultToastType().options)
const visible = ref(false)

watch(
  () => props.type,
  val => {
    const toastType = getToastType(val)
    if (toastType) {
      alert.color = toastType.options.color
      alert.bgColor = toastType.options.bgColor
      alert.icon = toastType.options.icon
    }
  },
  { immediate: true }
)

onMounted(() => {
  visible.value = true
  setTimeout(() => {
    visible.value = false
  }, props.duration)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "v-toast" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (alert.icon)
              ? (_openBlock(), _createBlock(_unref(iconVue), {
                  key: 0,
                  innerHTML: alert.icon
                }, null, 8, ["innerHTML"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass({ normal: __props.type != 'normal' })
            }, _toDisplayString(__props.message), 3)
          ])
        ], 512), [
          [_vShow, visible.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})